import type { HttpClient } from "@/core/services/protocols/types";
import { IDevLoginParams, IDevLoginResponse } from "../requests/types";
import { IDevGateway } from "./DevGateway";
import { injectable, inject } from "inversify";
import "reflect-metadata";
import { DITypes } from "@/core/@types/types";
@injectable()
export default class DevHttpGateway implements IDevGateway {
  @inject(DITypes.INDICADORES_HTTP_CLIENT)
  private httpClient!: HttpClient;

  async login(params: IDevLoginParams): Promise<IDevLoginResponse | undefined> {
    const response = await this.httpClient.get<IDevLoginResponse>({
      url: "dev/login",
      queryParams: params
    });

    if (!response) return undefined;

    return response.body;
  }
}
